module.exports = __webpack_public_path__ + "img/85800.5ca3720a.jpg";